const strings = {
  title: 'Membros da Associação',
  addUser: 'Adicionar',
}

export default strings
